$('body').addClass('lang-'+dataLayer[0].shoptet.language)
    if($('body').hasClass('lang-sk')){
        var loginacount = 'Užívateľské meno alebo e-mail'
        var loginpasword = 'Heslo'
        var zobrazuji = 'Zobraziť'
        var z = 'z'
        var favorite_text = 'Pridať k obľúbeným'
        var doprava_text = 'Informácie o bezpečnej preprave'
        var doruceni_text = 'Môžeme doručiť do: '
        var searchtitle = 'Zadaný výraz nebol nájdený'
        var searchsubtitle = 'Je nám to ľúto, ale nemohli sme k hľadanému výrazu nájsť zodpovedajúci produkt ani stránku. Zadajte iný výraz.'
        var emptycarttitle = 'Váš košík je prázdny.'
        var emptycartetext1 = 'Ak si neviete poradiť s výberom, neváhajte nás '
        var emptycartcontact = 'kontaktovať'
        var emptycarttext2 = 'Naši špecialisti vám poradia.'
        var linktocontact = '/kontakty/'
    
        var addtocart = 'Úspešne ste pridali do košíka'
        var tocart = 'Prejsť do košíka'
        var castonakupuji = 'S týmito produktami si zákazníci tiež kúpili­'
        var backtoshop = 'Späť do obchodu'
        var slevovypoukaz = 'Mám zľavový kupón'
        var incategory = 'Nájdené v kategóriách'
        var innews = 'Nájdené v článkoch'
        var popisprazdnykosik = 'Odporúčame pozrieť <a href="/detska-obuv/">detskú obuv</a>, <a href="/obuv-pre-dospelych/">obuv pre dospelých</a> alebo <a href = "/doplnky/">doplnky</a>.'
        //var nenalezeno = '<h2>Zadaný výraz nebol nájdený.</h2><p>Je nám to naozaj ľúto, ale nemohli sme nájsť produkt alebo stránku zodpovedajúcu vášmu hľadanému výrazu. Zadajte iný výraz.</p>'
        var backtoshoplink = 'Späť na e-shop'
        var darky_slevy = 'Darčeky a zľavy'

        var reglink = '/registracia'
        var regtext = 'Registrácia'

        var textstitky = 'Štítok'

        var registrace = '.in-registrace'
    }
    
